<div>
  <ng-container *ngIf="search">
    <div class="filter u--1/1 u-mb--">
      <div class="flex flex--middle" style="position: relative">
        <input
          [id]="context + '-search-input'"
          type="text"
          class="textbox u-p---"
          placeholder="Filter by"
          [(ngModel)]="query"
          (ngModelChange)="updateFilteredItems()"
        />
        <div class="filter__icon filter__icon--no-event">
          <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="var(--eds-icon-color)"
            viewBox="0 0 16 16"
            class="svg-icon"
          >
            <g id="Filter_-_16" data-name="Filter - 16">
              <path
                d="M14.9.9l-4.65,7A1.55,1.55,0,0,0,10,8.7v6.8a.5.5,0,0,1-.72.45l-3-1.5A.51.51,0,0,1,6,14V8.71a1.56,1.56,0,0,0-.25-.84L1.1.9A.58.58,0,0,1,1.58,0H14.42A.58.58,0,0,1,14.9.9Z"
              ></path>
            </g>
          </svg>
        </div>
      </div>
    </div>
  </ng-container>
  <div class="scroll-host" #panelScroll wfmScrollbar>
    <label [for]="context + '-select-all'" class="checkbox" [ngClass]="{ 'checkbox--error': error }">
      <input
        [id]="context + '-select-all'"
        type="checkbox"
        class="checkbox__input"
        [checked]="selectedAll"
        [indeterminate]="isAllIndeterminate"
        (click)="toggleSelectAll()"
      />
      <span class="checkbox__label" [class.checkbox__indeterminate]="isAllIndeterminate">{{
        'core.label.selectAll' | translate
      }}</span>
    </label>
    <hr class="u-mv0 u-mb---"/>
    <ng-container *ngFor="let item of (filteredItems || items) as list ; index as i; last as $last">
      <div class="checkbox-wrapper" [ngClass]="{ 'disabled': !item.availableForUser }">
        <label [for]="context + '-value-' + i" class="checkbox" [ngClass]="{ 'checkbox--error': error && item.availableForUser }">
          <input
            [id]="context + '-value-' + i"
            type="checkbox"
            class="checkbox__input"
            (click)="itemClick(item)"
            [checked]="value && (value === item || (value.indexOf && value.indexOf(item) >= 0))"
          />
          <span class="checkbox__label">{{ '' + (isListOfObjects ? item[labelField] : item) | translate }}</span>
        </label>
      </div>
      <hr class="u-mv0 u-mb---" *ngIf="isSeperatorRequired(item, i, list, $last)" />
    </ng-container>
  </div>
  <div class="flex" *ngIf="error">
    <svg-icon
      [name]="'ico-error-16'"
      [svgStyle]="{ 'width.px': 16, 'height.px': 21, fill: '#DF4661' }"
      [ngStyle]="{ height: '12px' }"
    >
    </svg-icon>
    <div class="u-pl---- u-pt---- text-12" id="popover-message">
      {{ 'searchModule.minimumSelection.msg' | translate }}
    </div>
  </div>
</div>
